var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.26257C0.723858 4.26257 0.5 4.48643 0.5 4.76257C0.5 5.03872 0.723858 5.26257 1 5.26257V4.26257ZM9 5.26257C9.27614 5.26257 9.5 5.03872 9.5 4.76257C9.5 4.48643 9.27614 4.26257 9 4.26257V5.26257ZM1 5.26257H9V4.26257H1V5.26257Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.762573C5.5 0.486431 5.27614 0.262573 5 0.262573C4.72386 0.262573 4.5 0.486431 4.5 0.762573L5.5 0.762573ZM4.5 8.76257C4.5 9.03872 4.72386 9.26257 5 9.26257C5.27614 9.26257 5.5 9.03872 5.5 8.76257L4.5 8.76257ZM4.5 0.762573L4.5 8.76257L5.5 8.76257L5.5 0.762573L4.5 0.762573Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.96ca65d37821467169338c93b42dc379.svg";
export { ForwardRef as ReactComponent };